import SecureBaseModel from './SecureBaseModel';

class CSModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static CS_UPDATE_SERVICE = 'cs-update-service';

    constructor() {
        super();
    }

    // params { userId: value, sessionId: value, orderNo: value, request: value }
    async updateService(params) {
        return await this.postData(CSModel.CS_UPDATE_SERVICE, params);
    }
}

export default CSModel;